import { createSlice } from "@reduxjs/toolkit";



// Define the initial state for the user slice
const initialState = {
  currentUser: null,
  cart: [],
  checkoutDetails: {
    addresses: [],
    userInfo:null,
    totalFinalPrice: 0,
    totalPriceWithTax:0,
    totalTaxAmount:0,
    checkoutItems: [],
    
  },
  cartLength:0,
  selectedAddress:null,
  orders:[],
  order:null,
    loading: false,
  error: false
};

// Create the user slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signInStart: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.currentUser = action.payload;
      state.loading = false;
      state.error = false;
    },
    signInFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSignOut:(state,action)=>{
      state.currentUser=null
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCart: (state, action) => {
      state.cart = action.payload;
    },
    setCartLength:(state,action)=>{
      state.cartLength=action.payload
    },
    setCheckoutDetails: (state, action) => {
        state.checkoutDetails = {
            addresses: action.payload.addresses || state.checkoutDetails.addresses,
            userInfo:action.payload.userInfo||state.checkoutDetails.userInfo,
            totalFinalPrice: action.payload.totalFinalPrice || state.checkoutDetails.totalFinalPrice,
            totalPriceWithTax:action.payload.totalPriceWithTax || state.checkoutDetails.totalPriceWithTax,
            totalTaxAmount:action.payload.totalTaxAmount || state.checkoutDetails.totalTaxAmount,
            checkoutItems: action.payload.checkoutItems || state.checkoutDetails.checkoutItems,
          }; 
      },
      setSelectedAddress:(state,action)=>{
        state.selectedAddress=action.payload
      },
      setAllOrders:(state,action)=>{
        state.orders=action.payload
      },
      setOrderDetails:(state,action)=>{
      
        state.order=action.payload
      }
  }
});

// Export actions and reducer
export const { 
  signInStart, 
  signInSuccess, 
  signInFailure, 
  setSignOut,
  setLoading,
  setCart, 
  setCartLength,
  setCheckoutDetails,
  setSelectedAddress,
  setAllOrders,
  setOrderDetails 
} = userSlice.actions;

export default userSlice.reducer;